import { render, staticRenderFns } from "./PeriodsModal.vue?vue&type=template&id=670ecc09&scoped=true"
import script from "./PeriodsModal.vue?vue&type=script&lang=js"
export * from "./PeriodsModal.vue?vue&type=script&lang=js"
import style0 from "./PeriodsModal.vue?vue&type=style&index=0&id=670ecc09&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ecc09",
  null
  
)

export default component.exports